/**
 * The stored column-role bindings of one organisation, `parameters/analyticsBindings`, beside
 * `parameters/analytics`. Each role binds to one ArTable by its prefixed collection id, a `TypeId`
 * and an optional `fields` path; only `salespersonMemberId` carries the `weighted` flag. The admin
 * edits it in Settings. `parseAnalyticsBindings` turns the raw document into
 * `ParsedAnalyticsBindings`, and the fact build, serving, the triggers and Settings all read that
 * result. The tables the roles name, `boundTablesOfAnalyticsBindings`, are the tables the lake ingests.
 */
import type { ArRawTableId, ColumnRoleId } from './Analytics.Catalog.types';
import type { ArBundleRole, TypeId } from './System.Artifacts.types';

export const ANALYTICS_BINDINGS_PATH = 'parameters/analyticsBindings';

/** One role's source: the ArTable, the cell `TypeId` it reads, and the path under the cell value. */
export type AnalyticsRoleBinding = { table: ArRawTableId; typeId: TypeId; fields?: string[] };

export type AnalyticsBindings = {
  roles: { [Role in Exclude<ColumnRoleId, 'salespersonMemberId'>]?: AnalyticsRoleBinding } & {
    salespersonMemberId?: AnalyticsRoleBinding & { weighted: boolean };
  };
  valueBundleRole?: ArBundleRole;
  projectReferenceKey?: string;
  ownerFieldId?: string;
};

/** A role the parser or the binder dropped, and why. The reason never quotes a stored value. */
export type AnalyticsBindingRejection = { role: ColumnRoleId; reason: string };

export type ParsedAnalyticsBindings = { bindings: AnalyticsBindings; rejected: AnalyticsBindingRejection[] };
